import _ from 'lodash';
import encodeGeonameAirportObj from './encodeGeonameAirportObj';

const encodeGeonameObj = (geoname) => {
  if (geoname && geoname.airportCode) {
    return encodeGeonameAirportObj(geoname);
  }
  return _.pick(geoname, ['featureClass', 'value', 'label', 'countryCode', 'city']);
};

export default encodeGeonameObj;
